// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class UserService {

    apiUrl: string;

    constructor(
        private http: HttpClient
    ) {
        this.apiUrl = AppSettings.API_PROD_ENDPOINT;
    }

    getUserByEmail(email): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const requesttUrl = this.apiUrl + `users?email=${email}`;
        console.log('_____requesttUrl_____'); console.log(requesttUrl)
        return this.http.get( requesttUrl, { headers } )
        .pipe(
            map((res: Response) => {console.log('_____res_____'); console.log(res); return res}),
            catchError(err => {
                console.error('Error: ' + err.error.code + ': ' +
                    err.error.message + ' (' +  err.status + ': ' +
                    err.statusText  + ')'
                );
                return err;
                })
        );
    }

}
